import axios from "axios";
const url = localStorage.getItem("verificationURL");

export async function apiGetUserVerificationFlows(data) {
    const payload = {
        filter: {},
        sort: {},
        limit: 0,
        offset: 0,
        ...data,
    };

    try {
        const response = await axios.post(`${url}/api/flow/setting/get`, payload, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem("a_t")}`
            }
        })

        return response?.data
    } catch (e) {
        console.error(e);
        throw e;
    }
}

export async function apiAssignUserVerificationProfile(flowSettingId) {
    try {
        const response = await axios.post(`${url}/api/user_verification/profile/assign`, flowSettingId, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem("a_t")}`,
                "Content-Type": "application/json"
            }
        })

        return response?.data
    } catch (e) {
        console.error(e);
        throw e;
    }
}

export async function apiGetUserVerificationProfile(data, urlVerification= "") {
    const payload = {
        filter: {},
        sort: {},
        limit: 0,
        offset: 0,
        ...data,
    };

    try {
        const response = await axios.post(`${urlVerification || url}/api/user_verification/profile/get`, payload, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem("a_t")}`
            }
        })

        return response?.data
    } catch (e) {
        console.error(e);
        throw e;
    }
}

export async function apiGetUserVerificationHistories(data) {
    const payload = {
        filter: {},
        sort: {},
        limit: 0,
        offset: 0,
        ...data,
    };

    try {
        const response = await axios.post(`${url}/api/user_verification/history/get`, payload, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem("a_t")}`
            }
        })

        return response?.data
    } catch (e) {
        console.error(e);
        throw e;
    }
}

export async function apiInitializeUserVerificationHistory(tierSettingId) {
    try {
        const response = await axios.post(`${url}/api/user_verification/history/init`, tierSettingId, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem("a_t")}`,
                "Content-Type": "application/json"
            }
        })

        return response?.data
    } catch (e) {
        console.error(e);
        throw e;
    }
}

export async function apiDuplicateUserVerificationHistory(payload) {
    try {
        const response = await axios.post(`${url}/api/user_verification/history/duplicate`, payload, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem("a_t")}`,
                "Content-Type": "application/json"
            }
        })

        return response?.data
    } catch (e) {
        console.error(e);
        throw e;
    }
}

export async function apiAbandonUserVerificationProfile() {
    try {
        const response = await axios.post(`${url}/api/user_verification/profile/abandon`, {}, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem("a_t")}`,
                "Content-Type": "application/json"
            }
        })

        return response?.data
    } catch (e) {
        console.error(e);
        throw e;
    }
}

export async function apiSaveUserVerificationHistory(data) {
    // example payload
    // {
    //     "_id": "68b6599c9b1da3789cde5453",
    //     "documents": [
    //         {
    //             "_id": "68ad7261d35b8057951fc6a9",
    //             "steps": [
    //                 {
    //                     "expiredAt": "2025-09-26T08:33:39.638Z",
    //                     "sourceId": "68ad714fd35b8057951fc6a6",
    //                     "value": "2006-01-02 15:04:05"
    //                 },
    //                 {
    //                     "expiredAt": "2025-10-26T08:33:39.638Z",
    //                     "sourceId": "68ad7163d35b8057951fc6a7",
    //                     "value": "assets\\6720ebc77259e722ec5702e21756198459_Screenshot 2025-08-06 094138.png"
    //                 }
    //             ]
    //         }
    //     ]
    // }
    try {
        const response = await axios.post(`${url}/api/user_verification/history/save`, data, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem("a_t")}`,
                "Content-Type": "application/json"
            }
        })

        return response?.data
    } catch (e) {
        console.error(e);
        throw e;
    }
}

export async function apiSubmitUserVerificationHistory(data) {
    // same payload with save
    try {
        const response = await axios.post(`${url}/api/user_verification/history/submit`, data, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem("a_t")}`,
                "Content-Type": "application/json"
            }
        })

        return response?.data
    } catch (e) {
        console.error(e);
        throw e;
    }
}

export async function apiUploadUserVerificationHistoryMedia(formData) {
    try {
        const response = await axios.post(`${url}/api/user_verification/history/upload`, formData, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem("a_t")}`,
            }
        })

        return response?.data
    } catch (e) {
        console.error(e);
        throw e;
    }
}

export async function apiUpdateUserVerificationHistoryStatus(data) {
    // example payload
    // {
    //     "_id" : "68aec8b744c8194e53f12e7d",
    //     "status" : "draft_verification" //draft_verification, verification_incomplete, pending_verification, verified, verification_failed, verification_expired
    // }

    try {
        const response = await axios.post(`${url}/api/user_verification/history/update_status`, data, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem("a_t")}`,
            }
        })

        return response?.data
    } catch (e) {
        console.error(e);
        throw e;
    }
}

export async function apiGetUserVerificationTiers(data) {

    const payload = {
        filter: {},
        sort: {
            tierLevel: 1
        },
        limit: 0,
        offset: 0,
        ...data,
    };

    try {
        const response = await axios.post(`${url}/api/tier/setting/get`, payload, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem("a_t")}`,
            }
        })

        return response?.data

    } catch (e) {
        console.error(e);
        throw e;
    }
}

export async function apiDeleteMediaResponse(fileName) {
    try {
        const response = await axios.delete(`${url}/assets/response/${fileName}`, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem("a_t")}`,
            }
        })

        return response?.data

    } catch (e) {
        console.error(e);
        throw e;
    }
}

export async function apiGetMediaResponse(fileRelativePath) {
    try {
        const response = await axios.get(`${url}/${fileRelativePath}`, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem("a_t")}`,
            }
        })

        return response?.data

    } catch (e) {
        console.error(e);
        throw e;
    }
}

export const apiGetVerificationTierSettingsAccessRights = async () => {

    try {

        const response = await axios.get(`${url}/api/tier/setting/access_right/list`, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem("a_t")}`,
            }
        });

        return response?.data
    } catch (e) {
        throw e;
    }
}

export async function apiCancelVerificationHistory(id) {
    try {
        const response = await axios.post(`${url}/api/user_verification/history/cancel`, JSON.stringify(id), {
            headers: {
                Authorization: `Bearer ${localStorage.getItem("a_t")}`,
            }
        })

        return response?.data

    } catch (e) {
        console.error(e);
        throw e;
    }
}
